import { render, staticRenderFns } from "./language.vue?vue&type=template&id=d479b7ac"
import script from "./language.vue?vue&type=script&lang=ts"
export * from "./language.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports